<template>
  <div class="container-fluid">

    <div class="page-title">
      <div class="row">
        <div class="col-12">
          <h3>Diagnóstico de reverdecimiento</h3>
        </div>
        <div class="col-6">
          <ol class="breadcrumb"></ol>
        </div>
      </div>
    </div>

    <div class="row starter-main justify-content-center">
      <div class="col-sm-12 col-md-8 col-lg-6">
        <div class="card" id="resultadoCard">
          <div class="card-header text-center">
            <h5 class="mb-0">Resultado de tu diagnóstico</h5>
          </div>

          <div class="card-body text-center py-5">
            <div v-if="resultado">
              <!-- Ícono de éxito -->
              <div class="resultado-icono mb-4">
                <vue-feather type="award" size="64" class="text-success"></vue-feather>
              </div>

              <!-- Nivel -->
              <h2 class="nivel-titulo mb-2">{{ resultado.nivel }}</h2>

              <!-- Puntaje total -->
              <p class="text-muted mb-4">
                Puntaje obtenido: <span class="badge bg-primary fs-6">{{ resultado.total }} pts</span>
              </p>

              <!-- Barra de progreso ilustrativa -->
              <div class="progress mb-4" style="height: 12px;">
                <div
                  class="progress-bar bg-success"
                  role="progressbar"
                  :style="{ width: progresoWidth }"
                  :aria-valuenow="resultado.total"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>

              <p class="text-muted small">
                Tu empresa ha sido evaluada con el folio <strong>#{{ resultado.respuesta_id }}</strong>.
                Guarda este número como referencia.
              </p>
            </div>

            <!-- Estado de error (sin datos) -->
            <div v-else class="text-muted">
              <vue-feather type="alert-circle" size="48" class="mb-3 text-warning"></vue-feather>
              <p>No se encontraron datos del resultado. Por favor vuelve a realizar el diagnóstico.</p>
            </div>
          </div>

          <div class="card-footer text-end">
            <router-link :to="{ name: 'quiz' }" class="btn btn-outline-secondary btn-sm me-2">
              <i class="fa fa-redo me-1"></i> Repetir diagnóstico
            </router-link>
            <router-link :to="{ name: 'bienvenida' }" class="btn btn-primary btn-sm">
              <i class="fa fa-home me-1"></i> Inicio
            </router-link>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "DiagnosticoResultado",

  data() {
    return {
      resultado: null,
    };
  },

  computed: {
    progresoWidth() {
      if (!this.resultado) return "0%";
      const pct = Math.min(100, Math.round((this.resultado.total / 100) * 100));
      return `${pct}%`;
    },
  },

  created() {
    const raw = this.$route.params.resultado;
    if (raw) {
      try {
        this.resultado = JSON.parse(raw);
      } catch {
        this.resultado = null;
      }
    }
  },
};
</script>

<style scoped>
#resultadoCard .card-header {
  background: linear-gradient(135deg, #09377c 0%, #1e59a2 100%);
  color: #fff;
}

.nivel-titulo {
  font-size: 1.75rem;
  font-weight: 700;
  color: #182e50;
}

.resultado-icono {
  color: #28a745;
}
</style>
